import { useState } from 'react';
import { Button, Modal } from 'semantic-ui-react';

interface ErrorModalProps {
  children: string | React.ReactNode;
  onClose?: () => void;
}

export function ErrorModal({ children, onClose }: ErrorModalProps) {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Modal.Header>Error</Modal.Header>
      <Modal.Content>{children}</Modal.Content>
      <Modal.Actions>
        <Button onClick={handleClose} primary>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
